<div class="p-4">
  <mat-card class="p-6">
    @if (userRolesLoading()) {
      <div class="flex justify-center p-4">
        <mat-spinner></mat-spinner>
      </div>
    } @else if (userRolesError()) {
      <div class="flex justify-center p-4">
        <p class="text-red-500">{{ errorText }}</p>
      </div>
    } @else {
      <h2 class="text-xl mb-6 font-medium">Add New User</h2>

      <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <!-- First Name -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" required />
              @if (userForm.get('firstName')?.hasError('required')) {
                <mat-error> First Name is required </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Last Name -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" required />
              @if (userForm.get('lastName')?.hasError('required')) {
                <mat-error> Last Name is required </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Email -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>Email</mat-label>
              <input matInput type="email" formControlName="email" required />
              @if (userForm.get('email')?.hasError('required')) {
                <mat-error> Email is required </mat-error>
              }
              @if (
                userForm.get('email')?.hasError('email') &&
                !userForm.get('email')?.hasError('required')
              ) {
                <mat-error> Please enter a valid email address </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Title -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>Title</mat-label>
              <input matInput formControlName="title" />
            </mat-form-field>
          </div>

          <!-- Fax Number -->
          <div>
            <mat-form-field class="w-full">
              <mat-label>Fax Number</mat-label>
              <input matInput formControlName="faxNumber" />
            </mat-form-field>
          </div>
        </div>

        <!-- User Permissions -->
        <div class="mb-8 flex items-center flex-col">
          <label class="block mb-2">User Permission</label>
          <mat-radio-group formControlName="roles" class="flex flex-col">
            @for (role of roles(); track role?.key) {
              <mat-radio-button [value]="role?.key">
                {{ role?.value }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>

        <!-- Action Buttons -->
        <div class="flex justify-end gap-4">
          <button type="button" mat-flat-button (click)="onCancel()" [disabled]="isCreatingUser()">
            CANCEL
          </button>
          <button
            type="submit"
            mat-flat-button
            color="primary"
            [disabled]="userForm.invalid || isCreatingUser()"
          >
            CREATE USER
          </button>
        </div>
      </form>
    }
  </mat-card>
</div>
